import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import React from "react";
import { formatDuration } from "@signolteam/shared/units-of-measure";

let defaultMetadata = {
  cd_total_seconds: "1169",
  /** Seconds of level flight */
  cd_cruise_count: "89",
  /** Seconds of ascending flight */
  cd_ascend_count: "12",
  /** Second durations of non-descending flight */
  constant_cd_threshold: "0.1",
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);
export default function graph({
  bvrColour,
  metadata = defaultMetadata,
  missingDataMsg,
  isExample,
}) {
  //metadata = defaultMetadata; //needed for testing if no real metadata
  let total = Number(metadata["cd_total_seconds"]);
  let level =
    Number(metadata["cd_cruise_count"]) + Number(metadata["cd_ascend_count"]);
  let threshold = Number(metadata["constant_cd_threshold"]);
  let limit = Number(total) * threshold;

  //need to check what the received data is like, maybe the threshold is the other way and need to do 1 - threshold

  if (!limit || !level) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }

  level = Number(level);

  const data = [
    {
      name: "Total descent time (ToD to 1,800ft AGL)",
      mobileName: "Descent",
      beforeThreshold: total > limit ? limit : total,
      afterThreshold: total > limit ? total - limit : 0,
      underThresholdColour:
        level > limit ? bvrColour.codes["200"] : bvrColour.codes["500"],
      overThresholdColour:
        level > limit ? bvrColour.codes["200"] : bvrColour.codes["500"],
    },
    {
      name: "Total level flight time during descent",
      mobileName: "Level",
      beforeThreshold: level > limit ? limit : level,
      afterThreshold: level > limit ? level - limit : 0,
      underThresholdColour:
        level > limit ? bvrColour.codes["200"] : bvrColour.codes["500"],
      overThresholdColour: bvrColour.codes["900"],
    },
  ];

  const domainMin = 0;
  const margin = total < limit ? 0.2 * limit : 0.2 * total;
  const domainMax =
    total < limit
      ? Math.ceil((limit + margin) / 10) * 10
      : Math.ceil((total + margin) / 10) * 10;
  const domain = [domainMin, domainMax];

  const mobileMargin = total < limit ? 0.05 * limit : 0.05 * total;
  const mobileDomainMax =
    total < limit
      ? Math.ceil(limit + mobileMargin)
      : Math.ceil(total + mobileMargin);
  const mobileDomain = [domainMin, mobileDomainMax];

  const thresholdLineColour = bvrColour.codes["900"];

  return (
    <BehaviourBarGraph
      data={data}
      threshold={limit}
      thresholdLabel={`Signol threshold${!isExample ? ` (${threshold * 100}%)` : ""}`}
      mobileDomain={mobileDomain}
      domain={domain}
      refLineColour={thresholdLineColour}
      success={level < limit}
      unitOfMeasure={` sec`}
      axisLabel={`Time`}
      hideYLine={true}
      hideNum={true}
      barLabelFormatter={(val) => formatDuration(val).formattedValue}
      isExample={isExample}
    />
  );
}
